var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "j-select-biz-component",
    _vm._g(
      _vm._b(
        {
          attrs: {
            value: _vm.value,
            ellipsisLength: 25,
            listUrl: _vm.url.list,
            columns: _vm.columns,
          },
        },
        "j-select-biz-component",
        _vm.attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }